import { render, staticRenderFns } from "./AdditionalModifierGroup.vue?vue&type=template&id=1ad1b5f5&"
import script from "./AdditionalModifierGroup.vue?vue&type=script&lang=js&"
export * from "./AdditionalModifierGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports